import {
  Badge,
  Breadcrumb,
  Col,
  Empty,
  Input, Pagination,
  Row,
  Select,
  Space,
  Spin,
  Table,
  notification,
} from "antd";
import Button from "antd/es/button";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";
import {
  getTagaDeviceList
} from "../../axios/api.account";

import {
  DeviceTypes
} from "../models";

import { useTranslation } from "react-i18next";

export const SmartGroupDevice = () => {
  const routeParams: any = useParams();
  const routeLocation: any = useLocation();
  const [data, setData] = useState<any>();
  const [searchName, setSearchName] = useState<string>("");
  const [searchState, setSearchState] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [tagInfo, setTagInfo] = useState<any>(routeLocation?.state);

  const { t } = useTranslation();

  useEffect(() => {
    console.log(routeParams,routeLocation,tagInfo);
    const {id, key,value } = tagInfo;
    setTagInfo({id, key,value});
    getList(pageIndex, pageSize);
  }, []);

  function onSearch() {
    getList(pageIndex, pageSize);
  }

  function getList(pgIndx: number, pgSize: number) {
    getTagaDeviceList(tagInfo?.id, {
        pageIndex: pgIndx,
        pageSize: pgSize,
        search: searchName
      }).then((res) => {
        setData(res.dataList);
        setTotalCount(res.totalCount)
        setPageSize(res.pageSize);
        setPageIndex(res.pageIndex);
      });
    }

  return (

    <div >
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("设备")}</Breadcrumb.Item>
          <Breadcrumb.Item><Link to={"/home/devices/smartGroups"}>{t("智能设备组")}</Link></Breadcrumb.Item>
          <Breadcrumb.Item>{t("设备组设备")}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Spin spinning={false}>
        <Row style={{ width: "100%" }}>
          <div className="borderBox">
            <div style={{display: "flex"}}>
              <img src="/images/applyDevice.png" style={{width: 70, height: 70}}/>
              <div style={{width: "100%"}}>
                  <Row style={{ fontSize: "16px" }}>
                      <Col span={18} style={{ textAlign: "left", display: "flex" }}> 
                          <span style={{
                              height: "25px",
                              fontSize: "18px",
                              fontWeight: 600,
                              color: "#333333",
                              lineHeight: "25px"
                          }}>{t("设备组设备")}</span>
                      </Col>
                  </Row>
                  <Row style={{fontSize: "16px" }}>
                      <Col span={24} >
                          {tagInfo?.key}
                      </Col>
                  </Row>
              </div>
          </div>
          </div>
          <Row className="borderBox">
            <Col style={{marginBottom: 11}}>
              <Space size={24}>
                <Space>
                  <span>{t("设备信息")}</span>
                  <Input
                    placeholder={t("输入设备型号，终端用户搜索")}
                    value={searchName}
                    onChange={(e) =>
                      setSearchName(e.target.value)
                    }
                  ></Input>
                </Space>
                <Button type="primary" onClick={() => { onSearch(); }}>
                  {t("查询")}
                </Button>
              </Space>
            </Col>
          </Row>
          <Row className="borderBox">
            <Col span={24}>
              <Table
                size="middle"
                className="minHeight"
                loading={loading}
                dataSource={data}
                pagination={false}
                onChange={(pagination) => { }}
                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
              >
                <Table.Column
                  title={t("设备名称")}
                  key="deviceName"
                  dataIndex="deviceName"
                ></Table.Column>
                <Table.Column
                  title={t("序列号")}
                  key="serialNo"
                  dataIndex="serialNo"
                ></Table.Column>
                <Table.Column title={t("用户")} key="userName" dataIndex="userName"></Table.Column>
                <Table.Column
                  title={t("设备类型")}
                  key="deviceType"
                  dataIndex="deviceType"
                  render={(v) => t(DeviceTypes[v])}
                ></Table.Column>
                <Table.Column title={t("设备型号")} key="model" dataIndex="model"></Table.Column>
                <Table.Column
                  title={t("平台")}
                  key="platform"
                  dataIndex="platform"
                ></Table.Column>
                <Table.Column
                  title={t("系统版本")}
                  key="osVersion"
                  dataIndex="osVersion"
                ></Table.Column>
                <Table.Column
                  title={t("操作")}
                  key="id"
                  dataIndex="id"
                  align="center"
                  render={(v: string, r: any) => {
                      return (
                          <Space>
                              <Link target="_blank" className="ant-btn ant-btn-link" style={{padding: "0 5px"}} to={`/home/devices/details/${v}`}>{t("设备详情")}</Link>
                          </Space>
                      );
                  }}
              ></Table.Column>
              </Table>
              <Pagination
                style={{ textAlign: "right", marginTop: "20px" }}
                pageSize={pageSize}
                current={pageIndex}
                total={totalCount}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} / ${total} ${t("条")}`
                }
                onChange={(page, pageSize) => {
                  getList(page, pageSize ? pageSize : 0);
                }}
                onShowSizeChange={(current, size) => getList(current, size)}
              ></Pagination>
            </Col>
          </Row>

        </Row>
      </Spin>
    </div>

  );
};
